const cloudPartners = [
  {
    name: 'AWS',
    svg: `<svg viewBox="0 0 120 50" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
      <!-- AWS text -->
      <text x="10" y="28" font-family="Arial, sans-serif" font-weight="bold" font-size="26" fill="#232F3E">aws</text>
      <!-- Orange smile arrow -->
      <path d="M10 35 Q35 45 65 35" stroke="#FF9900" stroke-width="3" fill="none" stroke-linecap="round"/>
      <polygon points="63,32 70,35 63,38" fill="#FF9900"/>
    </svg>`
  },
  {
    name: 'Google Cloud',
    svg: `<svg viewBox="0 0 160 50" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
      <!-- G icon segments -->
      <path d="M18 25 A10 10 0 1 1 28 35 L22 35 A4 4 0 1 0 18 25Z" fill="#4285F4"/>
      <path d="M28 25 L38 25 L38 29 L28 29Z" fill="#4285F4"/>
      <path d="M18 25 A10 10 0 0 1 28 15 L28 19 A6 6 0 0 0 18 25Z" fill="#EA4335"/>
      <path d="M28 15 A10 10 0 0 1 38 25 L34 25 A6 6 0 0 0 28 19Z" fill="#FBBC04"/>
      <path d="M38 25 A10 10 0 0 1 28 35 L28 31 A6 6 0 0 0 34 25Z" fill="#34A853"/>
      <!-- "Cloud" text -->
      <text x="44" y="32" font-family="Arial, sans-serif" font-size="16" fill="#5F6368">Cloud</text>
    </svg>`
  },
  {
    name: 'Microsoft Azure',
    svg: `<svg viewBox="0 0 160 50" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
      <!-- Azure diamond shape -->
      <polygon points="10,38 22,12 34,38" fill="#0078D4"/>
      <polygon points="22,12 38,38 34,38 26,22" fill="#0050A0"/>
      <!-- "Azure" text -->
      <text x="44" y="32" font-family="Arial, sans-serif" font-size="16" fill="#0078D4">Azure</text>
    </svg>`
  },
  {
    name: 'Oracle Cloud',
    svg: `<svg viewBox="0 0 160 50" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
      <!-- Oracle red ellipse -->
      <ellipse cx="22" cy="25" rx="14" ry="10" fill="#C74634"/>
      <ellipse cx="22" cy="25" rx="7" ry="10" fill="#FFFFFF"/>
      <!-- "ORACLE Cloud" text -->
      <text x="42" y="22" font-family="Arial, sans-serif" font-weight="bold" font-size="13" fill="#C74634">ORACLE</text>
      <text x="42" y="36" font-family="Arial, sans-serif" font-size="12" fill="#333333">Cloud</text>
    </svg>`
  },
  {
    name: 'Alibaba Cloud',
    svg: `<svg viewBox="0 0 160 50" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
      <!-- Alibaba stylized A -->
      <path d="M12 38 L22 12 L32 38 M16 30 L28 30" stroke="#FF6A00" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
      <!-- "Cloud" text -->
      <text x="38" y="32" font-family="Arial, sans-serif" font-size="15" fill="#FF6A00">Alibaba Cloud</text>
    </svg>`
  },
  {
    name: 'VMware',
    svg: `<svg viewBox="0 0 130 50" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
      <!-- VMware V shape -->
      <path d="M8 15 L18 35 L28 15" stroke="#607078" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
      <!-- "VMware" text -->
      <text x="34" y="32" font-family="Arial, sans-serif" font-weight="bold" font-size="17" fill="#607078">VMware</text>
    </svg>`
  },
  {
    name: 'Red Hat',
    svg: `<svg viewBox="0 0 130 50" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
      <!-- Red Hat fedora icon simplified -->
      <ellipse cx="20" cy="30" rx="14" ry="6" fill="#EE0000"/>
      <rect x="14" y="18" width="12" height="12" rx="6" fill="#EE0000"/>
      <rect x="6" y="28" width="28" height="4" rx="2" fill="#CC0000"/>
      <!-- "Red Hat" text -->
      <text x="42" y="32" font-family="Arial, sans-serif" font-weight="bold" font-size="16" fill="#EE0000">Red Hat</text>
    </svg>`
  },
  {
    name: 'Kubernetes',
    svg: `<svg viewBox="0 0 140 50" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
      <!-- Kubernetes steering wheel / helm icon simplified -->
      <circle cx="22" cy="25" r="13" fill="none" stroke="#326CE5" stroke-width="2.5"/>
      <circle cx="22" cy="25" r="4" fill="#326CE5"/>
      <!-- Spokes -->
      <line x1="22" y1="12" x2="22" y2="18" stroke="#326CE5" stroke-width="2.5" stroke-linecap="round"/>
      <line x1="22" y1="32" x2="22" y2="38" stroke="#326CE5" stroke-width="2.5" stroke-linecap="round"/>
      <line x1="9" y1="25" x2="15" y2="25" stroke="#326CE5" stroke-width="2.5" stroke-linecap="round"/>
      <line x1="29" y1="25" x2="35" y2="25" stroke="#326CE5" stroke-width="2.5" stroke-linecap="round"/>
      <line x1="13" y1="16" x2="17" y2="20" stroke="#326CE5" stroke-width="2.5" stroke-linecap="round"/>
      <line x1="27" y1="30" x2="31" y2="34" stroke="#326CE5" stroke-width="2.5" stroke-linecap="round"/>
      <line x1="31" y1="16" x2="27" y2="20" stroke="#326CE5" stroke-width="2.5" stroke-linecap="round"/>
      <line x1="17" y1="30" x2="13" y2="34" stroke="#326CE5" stroke-width="2.5" stroke-linecap="round"/>
      <!-- "Kubernetes" text -->
      <text x="42" y="30" font-family="Arial, sans-serif" font-size="14" fill="#326CE5">Kubernetes</text>
    </svg>`
  },
  {
    name: 'Terraform',
    svg: `<svg viewBox="0 0 140 50" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
      <!-- Terraform diamond/crystal icon -->
      <polygon points="22,10 32,20 22,30 12,20" fill="#7B42BC"/>
      <polygon points="22,32 32,22 32,38 22,48" fill="#5C2D91"/>
      <polygon points="12,22 22,32 22,48 12,38" fill="#9B6FD0"/>
      <!-- "Terraform" text -->
      <text x="40" y="30" font-family="Arial, sans-serif" font-size="14" fill="#7B42BC">Terraform</text>
    </svg>`
  }
]

export default cloudPartners
